import { render, staticRenderFns } from "./defaultV2.vue?vue&type=template&id=3cf32dd7"
var script = {}
import style0 from "./defaultV2.vue?vue&type=style&index=0&id=3cf32dd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports